export default {
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)
}